module.exports = __webpack_public_path__ + "static/img/join_11.0db9e84.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/join_11.jpg
// module id = 65+U
// module chunks = 1